import Api from '@/services/Api'
import store from '@/store/store'

// Zatvaranje otvorenih stavaka - veze izmedju racuna i uplata.
// Glavna knjiga se ne mijenja; veze stoje u zasebnoj tablici.
export default {

  // Cijelo stanje saldakonta - svaki dokument s otvorenim i zatvorenim dijelom.
  stanje (query) {
    return Api().get('zatvaranja/stanje', {params: query})
  },

  // Za povezati: uplate koje cekaju racun i racuni koji cekaju uplatu, s
  // prijedlogom veze uz svaki redak. Samo cita.
  zaPovezati (query) {
    return Api().get('zatvaranja/zapovezati', {params: query})
  },

  // Dodjela partnera uplati koja ga nema ({CompanyId, uplataId, partnerVATID, partnerName}).
  dodijeliPartnera (podaci) {
    return Api().post('zatvaranja/partner', podaci)
  },

  // Samo nepovezano, uz sazetak po partneru. Jedan popis za sve partnere.
  nepovezane (query) {
    return Api().get('zatvaranja/nepovezane', {params: query})
  },

  // Automatski prijedlozi povezivanja. Nista ne upisuje.
  prijedlozi (query) {
    return Api().get('zatvaranja/prijedlozi', {params: query})
  },

  // Jedan redak po partneru: otvoreni racuni, nepovezane uplate, saldo, dospjelo.
  otvorenePartneri (query) {
    return Api().get('zatvaranja/otvorenepartneri', {params: query})
  },

  // Cime je pojedini dokument zatvoren.
  veze (query) {
    return Api().get('zatvaranja/veze', {params: query})
  },

  // {CompanyId, veze: [{racunId, uplataId, iznos}], izvor, UserId, email}
  // Iznos je neobavezan - bez njega se zatvara koliko god je moguce.
  //
  // Server pri vezi 1:1 upise i staro polje (invoiceInNumber / invoiceOutNumber) na redak
  // uplate. Retci knjige koje drze otvoreni ekrani (store.mainledgerItems) to ne znaju,
  // pa se ovdje oznaci da su veze promijenjene - ekran dokumenta ih pri povratku osvjezi.
  async povezi (podaci) {
    const odgovor = await Api().post('zatvaranja/povezi', podaci)
    store.commit('oznaciVezePromijenjene')
    return odgovor
  },

  async odvezi (zatvaranjeId) {
    const odgovor = await Api().delete(`zatvaranja/${zatvaranjeId}`)
    store.commit('oznaciVezePromijenjene')
    return odgovor
  }
}
